import { Controller } from "@hotwired/stimulus"

// Hover (fine pointer) shows panel anchored under the trigger; touch / coarse opens on tap, closes on outside tap.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.prefersHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches
    this.outside = this.closeOnOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.outside, true)
  }

  onMouseEnter() {
    if (!this.prefersHover) return
    this.show()
  }

  onMouseLeave() {
    if (!this.prefersHover) return
    this.hide()
  }

  onClick(event) {
    if (this.prefersHover) return
    event.preventDefault()
    event.stopPropagation()
    if (this.isOpen()) {
      this.hide()
    } else {
      this.show()
      setTimeout(() => {
        document.addEventListener("click", this.outside, true)
      }, 1)
    }
  }

  closeOnOutsideClick(event) {
    if (this.element.contains(event.target)) return
    this.hide()
  }

  isOpen() {
    return !this.panelTarget.classList.contains("hidden")
  }

  show() {
    this.panelTarget.classList.remove("hidden")
    this.triggerButton?.setAttribute("aria-expanded", "true")
  }

  hide() {
    this.panelTarget.classList.add("hidden")
    this.triggerButton?.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this.outside, true)
  }

  get triggerButton() {
    return this.element.querySelector("button")
  }
}
